import React from 'react';
import logo from '../assets/logo.jpg';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { MenuItem, Typography } from '@mui/material';

function Header({ homeRef, menuRef, avisRef, contactRef }) {

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const pages = ["홈", "메뉴", "의견", "연락처"];
    const handleScroll = (page) => {
        switch (page) {
            case '홈':
                homeRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case '메뉴':
                menuRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case '의견':
                contactRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            case '연락처':
                avisRef.current.scrollIntoView({ behavior: 'smooth' });
                break;
            default:
                break;
        }
        handleCloseNavMenu();
    }

    return (
        <AppBar sx={{ backgroundColor: '#f8f6f4', overflow: 'hidden' }} position="fixed">
            <Container maxWidth="xl">
                <Toolbar disableGutters sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'row-reverse', md: 'row' }, justifyContent: { xs: 'center', md: 'initial' }, alignItems: 'center', m: 'auto' }}>
                        <Box sx={{ maxWidth: { xs: '80px', md: '150px' }, width: '100%', m: 'auto' }}>
                            <img src={logo} style={{ maxWidth: '100%', height: 'auto' }} alt="logo" />
                        </Box>

                        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', m: 'auto' }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="black"
                                sx={{ fontSize: { xs: '20px', md: '30px' } }} // adjust icon size
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                {pages.map((page) => (
                                    <MenuItem key={page} onClick={() => handleScroll(page)}>
                                        <Typography
                                            sx={{ textDecoration: 'none', color: 'black', fontFamily: "Gowun Batang", fontWeight: '700', fontSize: { xs: '16px', md: '18px' } }}
                                        >
                                            {page}
                                        </Typography>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>
                    </Box>
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center', gap: '120px', m: 'auto' }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={() => handleScroll(page)}
                                sx={{ fontSize: { xs: '20px', md: '58px' }, my: 2, color: 'black', display: 'block', fontFamily: "Gowun Batang", fontWeight: '700' }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default Header;